import { createSelector } from 'reselect';

export const selectActivePendingReviewSubmittal = createSelector(
  (state, submittalId) => state.swingSubmittals.pendingReview,
  (state, submittalId) => submittalId,
  (pendingReview, id) => {
    return pendingReview.get('data') ? pendingReview.get('data').find(s => s.get('id') === parseInt(id, 10)) : null;
  }
);

export const selectActiveHistorySubmittal = createSelector(
  (state, submittalId) => state.swingSubmittals.history,
  (state, submittalId) => submittalId,
  (submittalHistory, id) => {
    return submittalHistory.get('data')
      ? submittalHistory.getIn(['data', 'results']).find(s => s.get('id') === parseInt(id, 10))
      : null;
  }
);



// WEBPACK FOOTER //
// ./src/swing-submittals/selectors.js